/*
 * @Author: Chao Yang
 * @Date: 2020-01-02 15:38:04
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-08-13 00:51:16
 */
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ad-skeleton',
  templateUrl: './ad-skeleton.component.html',
  styleUrls: ['./ad-skeleton.component.scss'],
})
export class AdSkeletonComponent implements OnInit {
  @Input()
  appearance = '';
  @Input()
  count = 1;
  items: any[] = [];
  @Input()
  theme: { [k: string]: string } = {};
  styles: { [k: string]: any } = {};

  @Input() widthPercentage = 100;

  constructor() {}

  ngOnInit(): void {
    this.styles = this.theme || {};
    this.items.length = this.count;
  }
}
